import { model as i18nModel } from '!/i18n'
import { api } from '@setplex/tria-api'
import { combine } from 'effector'
import { extendMediaItemByLabelPriceTvShowSeason } from '~/shared/tools'

export const $seasonDetails = combine(
  api.tvshows.$tvShowSeason,
  i18nModel.$t,
  (tvShowSeason) =>
    tvShowSeason ? extendMediaItemByLabelPriceTvShowSeason(tvShowSeason) : null
)
